export default __webpack_public_path__ + "SpoqaHanSansNeo-Regular.452bf15.woff2";